'use client';

import { useRef, useState } from 'react';
import { useTranslations } from 'next-intl';
import { Filter, Sort } from '@/components/icons';

import FilterItem from './filter-item';
import PriceFilter from './priceFilter';
import FilterModal from '@/components/ui/modals/category-filter-modal';

const Filters = ({ updatedFilters, filters, isMobile }) => {
  console.log('updatedFilters ------------- ', updatedFilters)
  const t = useTranslations('common');
  const catMenuRef = useRef();
  const [modalType, setModalType] = useState(null);
  return (
    <>
      {!isMobile ? (
        <DesktopFilters filters={filters} />
      ) : (
        <MobileFilters
          ref={catMenuRef}
          t={t}
          setModalType={setModalType}
          modalType={modalType}
          filters={filters}
        />
      )}
    </>
  );
};

// Desktop filter
const DesktopFilters = ({ filters }) => {
  const colorFilters = Array.isArray(filters?.colors) ? filters.colors : [];
  const otherFilters = Array.isArray(filters?.others) ? filters.others : [];
  return (
    <div className='red-scroll sticky top-12 hidden overflow-y-auto rounded-lg px-2 md:flex md:max-h-[80svh]'>
      <div className='flex w-full flex-col gap-4'>
        {filters?.categories?.map((filter, idx) => (
          <FilterItem key={filter.code} data={filter} open={idx < 2} />
        ))}

        <PriceFilter />

        {[...colorFilters, ...otherFilters].map((filter, idx) => (
          <FilterItem
            key={filter.code}
            data={filter}
            open={idx < 2}
            isColor={filter.code === 'color'}
          />
        ))}
      </div>
    </div>
  );
};

//  Mobile filter
const MobileFilters = ({ ref, t, setModalType, modalType, filters }) => (
  <>
    <div
      ref={ref}
      className='sticky z-888 col-span-full mb-3.25 hidden w-[92vw] gap-4.5 pb-2 max-md:fixed max-md:start-1/2 max-md:bottom-16 max-md:flex max-md:h-fit max-md:items-center ltr:max-md:-translate-x-1/2 rtl:max-md:translate-x-1/2'
      // style={{ top: `calc(10px)` }}
    >
      {[
        { key: 'filter', icon: <Filter />, text: t('filter_key') },
        {
          key: 'sortBy',
          icon: <Sort color='black' />,
          text: t('sort_by_key'),
        },
      ].map(({ key, icon, text }) => (
        <button
          key={key}
          onClick={() => setModalType(key)}
          className={`flex w-1/2 items-center justify-center rounded-lg p-2 ${key == 'filter' ? 'bg-primary text-white' : 'border-primary border bg-white'}`}
        >
          {icon}
          <span className='mx-2 max-[991px]:text-xs'>{text}</span>
        </button>
      ))}
    </div>

    {/* Modal */}
    {modalType && (
      <FilterModal
        type={modalType}
        t={t}
        filters={filters}
        setModalType={setModalType}
        isMobile
      />
    )}
  </>
);

export default Filters;
